import React from "react";
import Style from '../../styles/landing/Suporte.module.css'; 
import { FaArrowLeft } from "react-icons/fa";

export default function ArtVerResultAval({ title }) {

  return (
    <div className={Style.containerArt}>
      <div className={Style.articleHeader}>
        <h2>{title}</h2>
      </div>
      <div className={Style.articleBody}>
        <p>
          Após enviar suas fotos, o resultado da avaliação fica disponível dentro
          da plataforma.
        </p>
        <ol>
          <li>Acesse o menu <strong>“Avaliações”</strong> ou histórico.</li>
          <li>Selecione a avaliação desejada.</li>
          <li>
            Veja os gráficos, medidas estimadas e comentários da análise
            inteligente.
          </li>
        </ol>
        <p>
          Caso não apareça, verifique sua conexão com a internet e atualize a
          página. Se o problema persistir, entre em contato com o suporte.
        </p>
      </div>
    </div>
  );
}